<template>
  <div class="search">
    <h2 class="text-center">Ricerca sentenze</h2>
    <p>Sentenze totali: <b>{{ numeroSentenze }}</b></p>

    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>

    <b-card class="m-md-4 px-md-5 px-sm-0 border-0">
      <b-input-group class="px-md-5 px-sm-0">
        <b-input-group-prepend>
          <b-input-group-text>
            <font-awesome-icon icon="keyboard" />
          </b-input-group-text>
        </b-input-group-prepend>
        <b-form-input id="input-query" class="text-center" v-model="form.query" @keyup.enter.prevent="searchNew()"
          placeholder="Cerca una sentenza..."></b-form-input>
        <b-input-group-append>
          <b-button id="info-search-text" variant="outline-info">
            <font-awesome-icon icon="question" />
          </b-button>
          <b-button v-b-toggle.ricerca-avanzata variant="outline-secondary">
            <span class="d-none d-sm-inline">Opzioni avanzate</span>
            <font-awesome-icon icon="angle-double-down" />
          </b-button>
          <b-button variant="outline-success" @click.prevent="searchNew()">
            <font-awesome-icon icon="search" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-popover target="info-search-text" triggers="hover" placement="bottom">
        <template v-slot:title><b>Sintassi di ricerca</b></template>
        <i>parola</i> (cerca una o più parole slegate tra loro)<br />
        <i>=parola</i> (cerca una parola esatta)<br />
        <i>-parola</i> (rimuove una parola dalla ricerca)<br />
        <i>"frase"</i> (cerca la frase esatta)<br />
        <i>pa*</i> (cerca tutte le parole che iniziano con pa)
      </b-popover>

      <b-collapse id="ricerca-avanzata" class="text-left px-md-5 px-sm-0 mt-4">
        <!-- TRIBUNALE -->
        <b-row>
          <b-col sm="3">
            <label for="tribunale">ORGANO GIUDIZIARIO:</label>
          </b-col>
          <b-col sm="9">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon icon="gavel" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select id="tribunale" v-model="form.tribunale">
                <template v-slot:first>
                  <option :value="``">Qualsiasi</option>
                </template>
                <option v-for="trib of data.tribunali" :key="trib.key" :value="trib.key">{{ trib.value }}</option>
              </b-form-select>
            </b-input-group>
          </b-col>
        </b-row>
        <!-- MATERIA -->
        <b-row>
          <b-col sm="3">
            <label for="materia">MATERIA:</label>
          </b-col>
          <b-col sm="3">
            <b-form-select id="materia_1" :options="data.materie1" @change="changeMateria1"
              v-model="filterMaterie.liv1">
              <template v-slot:first>
                <option :value="``">Qualsiasi</option>
              </template>
            </b-form-select>
          </b-col>
          <b-col sm="3">
            <b-form-select id="materia_2" :options="data.materie2" @change="changeMateria2"
              v-model="filterMaterie.liv2">
              <template v-slot:first>
                <option :value="filterMaterie.liv1">Qualsiasi</option>
              </template>
            </b-form-select>
          </b-col>
          <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon icon="book" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-select id="materia" :options="data.materie" v-model="form.materia">
                <template v-slot:first>
                  <option :value="filterMaterie.liv2 + `*`">Qualsiasi</option>
                </template>
              </b-form-select>
            </b-input-group>
          </b-col>
        </b-row>
        <!-- NUMERO e ANNO SENTENZA -->
        <b-row>
          <b-col sm="3">
            <label for="numero_sentenza">NUMERO SENTENZA:</label>
          </b-col>
          <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon icon="hashtag" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="numero_sentenza" v-model="form.numero_sentenza" type="number"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col sm="3">
            <label for="anno_sentenza">ANNO SENTENZA:</label>
          </b-col>
          <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon icon="calendar-day" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="anno_sentenza" v-model="form.anno_sentenza" type="number"></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <!-- NUMERO e ANNO R.G. -->
        <b-row>
          <b-col sm="3">
            <label for=".numero_rg">NUMERO R.G.:</label>
          </b-col>
          <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon icon="hashtag" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="numero_rg" v-model="form.numero_rg" type="number"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col sm="3">
            <label for="anno_rg">ANNO R.G.:</label>
          </b-col>
          <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon icon="calendar-day" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="anno_rg" v-model="form.anno_rg" type="number"></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <!-- NOME e CF GIUDICE -->
        <b-row>
          <b-col sm="3">
            <label for="nome_giudice">NOME GIUDICE:</label>
          </b-col>
          <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon icon="user-graduate" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="nome_giudice" v-model="form.nome_giudice" type="text"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col sm="3">
            <label for="cf_giudice">CF GIUDICE:</label>
          </b-col>
          <b-col sm="3">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>
                  <font-awesome-icon icon="address-card" />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input id="cf_giudice" v-model="form.cf_giudice" type="text"></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="text-right">
            <b-button @click="pulisciFiltri()" variant="outline-danger">
              <font-awesome-icon icon="broom" />Pulisci ricerca
            </b-button>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <b-container fluid>

      <!-- NEWSLETTER -->
      <b-row v-if="records">
        <b-col>
          <b-jumbotron class="p-3" lead="Vuoi rimanere aggiornato sulle nuove sentenze pubblicate?">
            <router-link
              :to="{ name: 'Newsletter', params: { materia: form.materia, tribunale: form.tribunale, testo: form.query } }">
              <b-button variant="outline-info">
                RICEVI AGGIORNAMENTI SETTIMANALI PER QUESTA RICERCA
              </b-button>
            </router-link>
            <b-button id="info-newsletter">
              <font-awesome-icon icon="question" />
            </b-button>
            <b-popover target="info-newsletter" triggers="hover" placement="bottom">
              <template v-slot:title>
                Selezionando il Tribunale e la materia di tuo interesse riceverai una mail settimanale con le ultime
                sentenze pubblicate al riguardo
              </template>
            </b-popover>
          </b-jumbotron>
        </b-col>
      </b-row>


      <!-- SEARCH RESULTS -->
      <b-row class="justify-content-end" v-if="records && records.length">
        <b-col sm="2">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <font-awesome-icon icon="sort-amount-down-alt" />
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select id="ordinamento" :options="data.ordinamento" v-model="form.ordinamento"
              @change="searchNew()">
            </b-form-select>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <h4 v-if="records && !records.length">Nessun risultato trovato!</h4>
          <h5 v-if="records && records.length">Trovati <b>{{ totalNum }}</b> risultati</h5>
          <b-list-group v-if="records">
            <result v-for="(result, index) in records" :key="result.id_atto" :sentenza="result" :index="index"
              :filters="form">
            </result>

            <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
              <div slot="no-more"></div>
              <div slot="no-results"></div>
            </infinite-loading>
          </b-list-group>
        </b-col>
      </b-row>
      <!--
      <hr />
      <b-row class="pt-1 sfondo-giustup">
        <b-col class="col-sm-3 embed-responsive embed-responsive-16by9 mx-auto">
          <youtube video-id="6o3bg_1GPhQ" :player-vars="{ autoplay: 1, loop: 1, rel: 0 }" mute="true"
            player-width="400" player-height="225"></youtube>
        </b-col>
      </b-row>
      -->
      <!-- COMMENTI E MASSIME -->
      <!--
      <b-row class="pt-3 sfondo-giustup text-body" v-if="!records">
        <b-col cols="12">
          <h5 class="font-weight-bold" style="color: white">MASSIME E COMMENTI ALLE SENTENZE</h5>
        </b-col>
      </b-row>
      <b-row class="sfondo-giustup text-body" v-for="commento in commenti" :key="commento.id" v-if="!records">
        <b-col sm="3"></b-col>
        <b-col sm="6" style="font-size: 14px;">
          <commento :input="commento" :showCommenta="true" :showTitoloSentenza="true" :showVisualizzazioni="true">
          </commento>
        </b-col>
      </b-row>
      -->
    </b-container>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Result from './Result.vue'
import Commento from '../Sentenza/Commento.vue';
import api from '../../services/search.js'
import service from '../../services/service.js'

export default {
  name: 'search',
  components: { Result, Commento, InfiniteLoading, Loading },
  data() {
    return {
      form: {
        query: '',
        tribunale: '',
        materia: '*',
        numero_sentenza: '',
        anno_sentenza: '',
        numero_rg: '',
        anno_rg: '',
        nome_giudice: '',
        cf_giudice: '',
        page: 1,
        ordinamento: 'data'
      },
      filterMaterie: {
        liv1: '',
        liv2: '',
      },
      loading: false,
      records: null,
      totalNum: null,
      data: {
        tribunali: [],
        materie: [],
        materie1: [],
        materie2: [],
        ordinamento: [
          {
            value: 'data',
            text: 'Data'
          },
          {
            value: 'attinenza',
            text: 'Attinenza'
          }
        ]
      },
      commenti: [],
      numeroSentenze: ''
    }
  },
  methods: {

  async checkLogged() {
    let data = await service.execute('get', 'oauth');
    return data;
  },
    async searchNew() {
      this.form.page = 1;
      this.records = [];

      await this.search();
      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.stateChanger.reset();
      }
    },
    async search() {
      this.loading = true;
      let data = [];

      try {
        data = await api.search(this.form);
      }
      catch (e) {
        alert("Errore durante la ricerca!");
      }
      this.totalNum = data.totalNum;

      this.records.push(...data.sentenze);

      this.form.page += 1;
      this.loading = false;
      return data.sentenze.length;
    },
    infiniteHandler($state) {
      if (this.records.length) {
        this.search().then((res) => {
          if (res) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      }
      else {
        $state.complete();
      }
    },
    changeMateria1(value) {
      // clean old second level to avoid sending it as a filter
      this.filterMaterie.liv2 = '';
      api.getMaterie(this.filterMaterie).then((data) => {
        this.data.materie2 = data;
        // update the default value of materia2 to be "Qualsiasi"
        this.filterMaterie.liv2 = value;
        // update the default value of materia to be "Qualsiasi"
        this.form.materia = value + '*';
      });
    },
    changeMateria2(value) {
      api.getMaterie(this.filterMaterie).then((data) => {
        this.data.materie = data;
        // update the default value of materia to be "Qualsiasi"
        this.form.materia = value + '*';
      });
    },
    pulisciFiltri() {
      this.form.query = '';
      this.form.tribunale = '';
      this.form.materia = '*';
      this.form.numero_sentenza = '';
      this.form.anno_sentenza = '';
      this.form.numero_rg = '';
      this.form.anno_rg = '';
      this.form.nome_giudice = '';
      this.form.cf_giudice = '';
      this.filterMaterie.liv1 = '';
      this.filterMaterie.liv2 = '';
    },
    async getCommenti() {
      this.commenti = await service.execute('get', 'commento');
    },
    async getNumeroSentenze() {
      this.numeroSentenze = await service.execute('get', 'cercasentenze/numero');
    }
  },

  async created() {
    if (!(await this.checkLogged())) {
      this.$router.push({ name: "Home"})
    }
    let data = await api.getTribunali();
    this.data.tribunali = data;

    data = await api.getMaterie(this.filterMaterie);
    this.data.materie1 = data;

    this.getCommenti();
    this.getNumeroSentenze();
    this.$parent._data.loaded = true;
      // this.$router.push({ name: "Home"}  )
  }
}
</script>

<style>
label {
  line-height: 38px;
}

.selected {
  background-color: yellow;
}

.sfondo-giustup {
  background-color: #008bc0;
}
</style>



// WEBPACK FOOTER //
// src/components/Search/Search.vue